module.exports = __webpack_public_path__ + "0562acd551f2bfbc5997a2b2ba9da791.svg";